<template>
    <div>
        <div class="mb-3">
            <div class="col-md-12">
                <div class="tw-mt-2 overflow-auto tw-max-h-40">
                    <div class="table-ui-detail">
                        <table>
                            <thead>
                                <tr>
                                    <th width="10%">
                                        {{ $t('customer.photo') }}
                                    </th>
                                    <th width="25%" class="text-center">
                                        {{ $t('customer.customerCode') }}
                                    </th>
                                    <th>
                                        {{ $t('customer.nameEn') }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(customer, index) in customers"
                                    :key="index"
                                >
                                    <td class="tw-whitespace-nowrap">
                                        <img
                                            class="tw-rounded tw-h-8"
                                            v-lazy="{
                                                src: photo(customer),
                                                error:
                                                    customer.sex == 'Male'
                                                        ? require('@/assets/staff-default-man.png')
                                                        : require('@/assets/staff-default-women.png'),
                                                loading: require('@/assets/Rolling-1s-200px.svg'),
                                                preLoad: 1.3,
                                                attempt: 1
                                            }"
                                        />
                                    </td>
                                    <td
                                        class="tw-whitespace-nowrap text-center"
                                    >
                                        {{ customer.customer_code }}
                                    </td>
                                    <td class="tw-whitespace-nowrap">
                                        {{ customer.customer_name_en }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label required">{{
                    $t('customer.toBranch')
                }}</label>
                <Select
                    v-model="model.branch_id"
                    filterable
                    clearable
                    :placeholder="$t('customer.typeToSearch')"
                    :class="{
                        'ivu-form-item-error': errors.has('branch_id')
                    }"
                >
                    <Option
                        v-for="(branch, index) in branches"
                        :value="branch.branch_id"
                        :key="index"
                        :label="branch.branch_name_en"
                    >
                        {{ branch.branch_name_en }}
                    </Option>
                </Select>
                <div class="text-danger" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                </div>
            </div>
        </div>
        <div class="mb-3">
            <div class="col-md-12">
                <label class="form-col-label control-label">{{
                    $t('customer.transferReason')
                }}</label>
                <textarea class="form-control" v-model="model.transfer_reason">
                </textarea>
                <div class="text-danger" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                </div>
            </div>
        </div>
        <div class="tw-flex tw-justify-end tw-space-x-2 tw-sh">
            <ts-button @click.prevent="() => $emit('cancel')" class="btn-gray">
                {{ $t('cancel') }}</ts-button
            >
            <ts-button
                color="primary"
                @click.prevent="onMove"
                :waiting="waiting"
                class="btn btn-primary d-block"
            >
                {{ $t('move') }}</ts-button
            >
        </div>
        <Spin size="large" fix v-if="loading"> </Spin>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'moveBranch',
    props: ['customers'],
    data () {
        return {
            errors: new Errors(),
            loading: false,
            waiting: false,
            model: {
                customer_id: [],
                branch_id: null,
                transfer_reason: null
            }
        }
    },
    computed: {
        ...mapState('creditOperation/customer', ['branches'])
    },
    methods: {
        ...mapActions('creditOperation/customer', ['getBranch']),
        photo (record) {
            if (record.photo) {
                return record.photo
            }

            return record.sex == 'Male'
                ? require('@/assets/staff-default-man.png')
                : require('@/assets/staff-default-women.png')
        },
        async fetchResource () {
            this.errors = new Errors()
            this.loading = true
            this.clear()
            await this.getBranch()
            this.model.customer_id = []
            if (this.customers.length > 0) {
                this.customers.map(row => {
                    this.model.customer_id.push(row.customer_id)
                })
            }
            this.loading = false
        },
        onMove () {
            this.errors = new Errors()
            this.waiting = true
            this.$store
                .dispatch('creditOperation/customer/moveBranch', this.model)
                .then(response => {
                    this.notice({
                        type: response.message_id == 0 ? 'success' : 'warning',
                        text: response.message
                    })
                    if(response.message_id == 0)
                    {
                        this.$emit('cancel')
                        this.$emit('fetchData')
                        this.clear()
                    }
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.notice({ type: 'error', text: error.message })
                })
                .finally(() => {
                    this.waiting = false
                })
        },
        clear(){
            this.model.customer_id = []
            this.model.branch_id = null
            this.model.transfer_reason = null
        },
        notice (not) {
            this.$Notice[not.type]({
                title: 'CUSTOMER',
                desc: not.text
            })
        }
    }
}
</script>
